// extracted by mini-css-extract-plugin
export default {"searchBar":"AsyncSearchBar_searchBar__oWf5R"};